import React from 'react'

import { recorridoData as CData } from '../data/recorridoComerciales.data';
import { recorridoData as PData } from '../data/recorridoParticulares.data';
import { carDataInteriores as IData } from '../data/ParticularesInterior.data';


import { colorsData } from './../data/ParticularesColors.data';

import Viewer360 from './Canvas/viewer360/Viewer360.component';
import TopMenu from './Canvas/topMenu/topMenu.component';
import Sidebar from './Canvas/sidebar/sidebar.component';
import CarMenu from './Canvas/carMenu/carMenu.component';
import Viewer3D from './Canvas/viewer3D/viewer3D.component';
import VideoComponent from './Canvas/video/video.component';
import TopMenuMobile from './Canvas/topMenu/topMenuMobile.component';
import CarMenuMobile from './Canvas/carMenu/carMenuMobile.component';
import Info from './Canvas/infoScreen/info.component';
import Tutorial from './Ingreso/Tutorial.component'

import MobileCheck from './mobileCheck'
import back from './../UI/canvas/carmenu/salir_interior_white.svg'

import handleOpenFullScreen from './fullscreen'
interface Props {
    isComerciales: boolean,
}

declare const window: any;

interface State {
    currentPanorama: any,
    currentScene: any,
    currentExtSceneName: string,
    currentInteriorPayloaded: string

    sidebarOpened: boolean,
    isCarMenuOpened: boolean,
    renderFromMenu: boolean,
    renderEverything: boolean,

    selectedFamily: string,
    selectedFamilyIndex: number

    selectedIndividual: string,
    selectedIndividualIndex: number,

    currentSet: any,
    currentColorsArray: any,
    currentColorIndex: number,
    currentColor: any,

    showLegalNote: boolean

    showSpin: boolean,
    videoLink: string,
    isVideo: boolean,
    isMobile: boolean,

    isInfoOpened: false,
    currentInfoText: [],
    currentInfoImg: "",

    showInterior: boolean,
    isTuto: boolean,
    isFullScreen: boolean,
    isInteriorOn: boolean,
    canvasSelectedIndex: number
}

interface Canvas {
    location: any
}


class Canvas extends React.Component<Props, State>{

    constructor(props: Props) {
        super(props);
        this.state = {
            currentPanorama: "",
            currentScene: {},
            currentExtSceneName: "",
            currentInteriorPayloaded: "",

            sidebarOpened: false,
            isCarMenuOpened: false,
            renderFromMenu: false,
            renderEverything: false,

            selectedFamily: "",
            selectedFamilyIndex: -1,

            selectedIndividual: "",
            selectedIndividualIndex: -1,

            currentSet: [],
            currentColorsArray: [],
            currentColorIndex: -1,
            currentColor: "",

            showLegalNote: false,

            showSpin: false,
            videoLink: "",
            isVideo: false,
            isMobile: false,

            isInfoOpened: false,
            currentInfoText: [],
            currentInfoImg: "",

            showInterior: false,
            isTuto: false,
            isFullScreen: false,
            isInteriorOn: false,
            canvasSelectedIndex: -1
        }
    }

    componentDidMount() {
        const mobile = /*MobileCheck() &&*/ (window.innerHeight > window.innerWidth)
        this.setState({ isMobile: mobile })
        window.addEventListener('resize', this.update)

        if (window.location.href.includes("?SPIN")) {
            this.setState({
                selectedIndividual: window.location.href.split("=")[1].replaceAll("_", " "),
                showSpin: true,
                currentColor: colorsData()[0][window.location.href.split("=")[1].replaceAll("_", " ")].Colors[0] ? colorsData()[0][window.location.href.split("=")[1].replaceAll("_", " ")].Colors[0].Name : this.state.currentColor,
                currentColorsArray: colorsData()[0][window.location.href.split("=")[1].replaceAll("_", " ")].Colors ? colorsData()[0][window.location.href.split("=")[1].replaceAll("_", " ")].Colors : this.state.currentColorsArray,
                currentColorIndex: 0,
                renderFromMenu: true,
            })
        }
        else if (window.location.href.includes("?INTERIOR")) {
            this.setState({
                showInterior: true,
                renderFromMenu: true,
                showSpin: false,
                currentPanorama: this.props.isComerciales ? IData()[0][window.location.href.split("=")[1].replaceAll("_", " ") + " INTERIOR"].Image : IData()[0][window.location.href.split("=")[1].replaceAll("_", " ") + " INTERIOR"].Image,
                currentScene: this.props.isComerciales ? IData()[0][window.location.href.split("=")[1].replaceAll("_", " ") + " INTERIOR"] : IData()[0][window.location.href.split("=")[1].replaceAll("_", " ") + " INTERIOR"],
            })
        }
        else if (window.location.href.includes("?SHOWROOM=FAMILIA")) {
            console.log('entra')
            this.setState({
                //selectedIndividual: window.location.href.split("=")[1].replaceAll("_", " "),
                currentPanorama: this.props.isComerciales ? CData()[0][window.location.href.split("=")[1].replaceAll("_", " ")].Image : PData()[0][window.location.href.split("=")[1].replaceAll("_", " ")].Image,
                currentScene: this.props.isComerciales ? CData()[0][window.location.href.split("=")[1].replaceAll("_", " ")] : PData()[0][window.location.href.split("=")[1].replaceAll("_", " ")],
                renderFromMenu: true,
                //isCarMenuOpened: true,
                sidebarOpened: false,
                currentExtSceneName: window.location.href.split("=")[1].replaceAll("_", " "),
                //showSpin: false
            })
        }
        else if (window.location.href.includes("?SHOWROOM")) {
            this.setState({
                selectedIndividual: window.location.href.split("=")[1].replaceAll("_", " "),
                currentPanorama: this.props.isComerciales ? CData()[0][window.location.href.split("=")[1].replaceAll("_", " ")].Image : PData()[0][window.location.href.split("=")[1].replaceAll("_", " ")].Image,
                currentScene: this.props.isComerciales ? CData()[0][window.location.href.split("=")[1].replaceAll("_", " ")] : PData()[0][window.location.href.split("=")[1].replaceAll("_", " ")],
                renderFromMenu: true,
                isCarMenuOpened: true,
                sidebarOpened: false,
                currentExtSceneName: window.location.href.split("=")[1].replaceAll("_", " "),
                showSpin: false
            }, () => {
                if (colorsData()[0][this.state.selectedIndividual].Colors && colorsData()[0][this.state.selectedIndividual].Colors[0]) {
                    this.setState({
                        currentColor: colorsData()[0][this.state.selectedIndividual].Colors[0].Name,
                        currentColorsArray: colorsData()[0][this.state.selectedIndividual].Colors,
                    })
                }
            })
        }
        else {
            this.setState({
                renderFromMenu: true,
                currentPanorama: this.props.isComerciales ? CData()[0]["START"].Image : PData()[0]["START"].Image,
                currentScene: this.props.isComerciales ? CData()[0]["START"] : PData()[0]["START"],
            })
        }
    }

    update = () => {
        const mobile = /*MobileCheck() &&*/ (window.innerHeight > window.innerWidth)
        this.setState({ isMobile: mobile })
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.isComerciales !== this.props.isComerciales) {
            window.location.reload()
        }
    }

    handleOpenSidebar = () => {
        this.setState({
            sidebarOpened: !this.state.sidebarOpened
        })
    }

    handleSelectFamily = (payload: string, index: number) => {
        window.paramsObj = {
            "section-hierarchy": payload,
            "section-plain": payload
        };
        window.ym(85857749, "params", window.paramsObj || {});
        this.setState({
            selectedFamily: payload,
            selectedFamilyIndex: index
        })
    }

    handleSelectIndividual = (payload: string, index: number) => {
        window.paramsObj = {
            "section-hierarchy": payload,
            "section-plain": payload
        };
        this.setState({
            selectedIndividual: payload,
            selectedIndividualIndex: index,
            currentPanorama: this.props.isComerciales ? CData()[0][payload].Image : PData()[0][payload].Image,
            currentScene: this.props.isComerciales ? CData()[0][payload] : PData()[0][payload],
            renderFromMenu: true,
            isCarMenuOpened: true,
            sidebarOpened: false,
            showInterior: false,
            currentExtSceneName: payload,
            showSpin: false
            
        }, () => {
            if (colorsData()[0][this.state.selectedIndividual].Colors && colorsData()[0][this.state.selectedIndividual].Colors[0]) {
                this.setState({
                    currentColor: colorsData()[0][this.state.selectedIndividual].Colors[0].Name,
                    currentColorsArray: colorsData()[0][this.state.selectedIndividual].Colors,
                })
            }
        })
    }

    handleChangePano = (payload: string, renderEverything: boolean) => {
        this.setState({
            renderFromMenu: false,
            currentPanorama: this.props.isComerciales && !this.state.showInterior ? CData()[0][payload].Image : PData()[0][payload].Image,
            currentScene: this.props.isComerciales && !this.state.showInterior ? CData()[0][payload] : PData()[0][payload],
            renderEverything: renderEverything,
            isCarMenuOpened: payload.includes("DIG DER") || payload.includes("DIG IZQ") || payload.includes("LAT DER") || payload.includes("LAT IZQ") || payload.includes("POSTERIOR")
        }, () => {
            if (this.state.renderEverything) {
                this.setState({
                    currentExtSceneName: payload,
                    selectedIndividual: payload.includes("FAMILIA") || payload.includes("GENERAL") || payload.includes("START") ? "" : !payload.includes("DIG DER") && !payload.includes("DIG IZQ") && !payload.includes("LAT DER") && !payload.includes("LAT IZQ") && !payload.includes("POSTERIOR") ? payload : this.state.selectedIndividual,
                    isCarMenuOpened: payload.includes("FAMILIA") || payload.includes("GENERAL") || payload.includes("START") ? false : true,
                    currentInteriorPayloaded: payload.includes("FAMILIA") || payload.includes("GENERAL") || payload.includes("START") || payload.includes("DIG DER") || payload.includes("DIG IZQ") || payload.includes("LAT DER") || payload.includes("LAT IZQ") || payload.includes("POSTERIOR") ? this.state.currentInteriorPayloaded : payload
                })
                if(!payload.includes("DIG DER") && !payload.includes("DIG IZQ") && !payload.includes("LAT DER") && !payload.includes("LAT IZQ") && !payload.includes("POSTERIOR") && !payload.includes("GENERAL") && !payload.includes("START")){
                    window.paramsObj = {
                        "section-plain": payload,
                        };
                        window.ym(85857749, "params", window.paramsObj || {});
                }
            }
        })

    }

    handleChangeColors = (index: number) => {
        this.setState({
            currentSet: [],
            currentColor: colorsData()[0][this.state.selectedIndividual].Colors[index].Name,
            currentColorsArray: colorsData()[0][this.state.selectedIndividual].Colors,
            currentColorIndex: index
        })
    }

    handleCloseSpin = () => {
        this.setState({
            showSpin: false
        }, () => {
            this.handleOpenSpin(-1)
        })
    }

    handleOpenInterior = (payload, index) => {
        if (index !== -1) {
            this.setState({
                renderFromMenu: true,
                showInterior: true,
                showSpin: false,
                currentPanorama: this.props.isComerciales ? IData()[0][payload].Image : IData()[0][payload].Image,
                currentScene: this.props.isComerciales ? IData()[0][payload] : IData()[0][payload],
                canvasSelectedIndex: index
            })
        }
        else if (index === -1) {
            this.setState({
                isInteriorOn: false,
                renderFromMenu: true,
                showInterior: false,
                showSpin: false,
                currentPanorama: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName].Image : PData()[0][this.state.currentExtSceneName].Image,
                currentScene: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName] : PData()[0][this.state.currentExtSceneName],
                canvasSelectedIndex: index
            })
        }
    }

    handleOpenBaul = (payload, index) => {
        if (index !== -1) {
            this.setState({
                renderFromMenu: true,
                showInterior: true,
                showSpin: false,
                currentPanorama: this.props.isComerciales ? IData()[0][payload].Image : IData()[0][payload].Image,
                currentScene: this.props.isComerciales ? IData()[0][payload] : IData()[0][payload],
                canvasSelectedIndex: index
            })
        }
        else if (index === -1) {
            this.setState({
                isInteriorOn: false,
                renderFromMenu: true,
                showInterior: false,
                showSpin: false,
                currentPanorama: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName].Image : PData()[0][this.state.currentExtSceneName].Image,
                currentScene: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName] : PData()[0][this.state.currentExtSceneName],
                canvasSelectedIndex: index
            })
        }
    }

    handleOpenSpin = (index) => {
        if (index !== -1) {
            this.setState({
                showSpin: true,
                currentPanorama: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName].Image : PData()[0][this.state.currentExtSceneName].Image,
                currentScene: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName] : PData()[0][this.state.currentExtSceneName],
                currentColor: colorsData()[0][this.state.selectedIndividual].Colors[0] ? colorsData()[0][this.state.selectedIndividual].Colors[0].Name : "",
                currentColorsArray: colorsData()[0][this.state.selectedIndividual].Colors ? colorsData()[0][this.state.selectedIndividual].Colors : this.state.currentColorsArray,
                currentColorIndex: 0,
                canvasSelectedIndex: index
            }, () => {
                console.log(this.state.currentColor, this.state.selectedIndividual)
            })
        }
        if (index === -1) {
            this.setState({
                showSpin: false,
                currentPanorama: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName].Image : PData()[0][this.state.currentExtSceneName].Image,
                currentScene: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName] : PData()[0][this.state.currentExtSceneName],
                canvasSelectedIndex: index
            })
        }
    }

    handleResetStates = () => {
        console.log();

        this.setState({
            showSpin: false,
            isVideo: false,
            canvasSelectedIndex: -1
        }, () => {
            this.handleOpenInterior(this.state.currentExtSceneName, -1)
        })
    }

    handleOpenVideo = (payload: any, videoLink: string) => {
        if (payload === -1) {
            console.log("entro");
            
            this.setState({
                showSpin: false,
                isVideo: false,
                videoLink: "",
                currentPanorama: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName].Image : PData()[0][this.state.currentExtSceneName].Image,
                currentScene: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName] : PData()[0][this.state.currentExtSceneName],
                canvasSelectedIndex: payload
            })
        }
        else {
            console.log(PData()[0]);
            
            this.setState({
                showSpin: false,
                isVideo: true,
                videoLink: videoLink,
                currentPanorama: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName].Image : PData()[0][this.state.currentExtSceneName].Image,
                currentScene: this.props.isComerciales ? CData()[0][this.state.currentExtSceneName] : PData()[0][this.state.currentExtSceneName],
                canvasSelectedIndex: payload
            })
        }
    }

    handleOpenInfoScreen = (payload: any, img: any, text: any) => {
        this.setState({
            isInfoOpened: payload,
            currentInfoImg: img,
            currentInfoText: text
        })
        window.paramsObj = {
            "section-plain":this.state.selectedFamily+">"+this.state.selectedIndividual+">"+text.normalize('NFD').replace(/[\u0300-\u036f]/g,""),
            };
            window.ym(85857749, "params", window.paramsObj || {});
    }

    handleShowTuto = (videoLink:any) => {
        this.setState({
            isTuto: true,
            showSpin: false,
            isVideo: true,
            videoLink: videoLink,
        })
    }
    handlecloseTuto = (state:any) => {
        this.setState({
            isTuto: state,
            showSpin: false,
            isVideo: state,
        })
    }

    handleFullScreen = () => {
        this.setState({
            isFullScreen: !this.state.isFullScreen
        })
        handleOpenFullScreen(this.state.isFullScreen)
    }

    handleOnInterior = () => {
        this.setState({
            isInteriorOn: !this.state.isInteriorOn
        }, () => {
            if (this.state.isInteriorOn) {
                this.setState({
                    currentPanorama: this.props.isComerciales ? IData()[0][this.state.selectedIndividual + " INTERIOR ON"].Image : IData()[0][this.state.selectedIndividual + " INTERIOR ON"].Image,
                    currentScene: this.props.isComerciales ? IData()[0][this.state.selectedIndividual + " INTERIOR ON"] : IData()[0][this.state.selectedIndividual + " INTERIOR ON"],
                })
            }
            else {
                this.setState({
                    currentPanorama: this.props.isComerciales ? IData()[0][this.state.selectedIndividual + " INTERIOR"].Image : IData()[0][this.state.selectedIndividual + " INTERIOR"].Image,
                    currentScene: this.props.isComerciales ? IData()[0][this.state.selectedIndividual + " INTERIOR"] : IData()[0][this.state.selectedIndividual + " INTERIOR"],
                })
            }
        })
    }

    render(): React.ReactNode {
        return (
            <div className='main-showroom-canvas'>
                {
                    !this.state.isMobile ?
                        <React.Fragment>
                            <Viewer360
                                currentScene={this.state.currentScene}
                                handleChangePano={this.handleChangePano}
                                handleOpenBullet={this.handleOpenInfoScreen}
                                handleShowInterior={this.handleOpenInterior}
                                renderFromMenu={this.state.renderFromMenu}
                                isMobile={this.state.isMobile}
                                isComerciales={this.props.isComerciales}
                                handleOnInterior={this.handleOnInterior}
                            />
                            {
                                this.state.showInterior ?
                                <div className='back-exits' onClick={() => {this.handleOpenInterior(this.state.canvasSelectedIndex, -1)}}>
                                    <img src={back}>
                                    </img>
                                    <div className='back-text'>
                                        Quiero Salir
                                    </div>
                                </div>: null
                            }
                            {this.state.showSpin ?
                                <Viewer3D
                                    individualSelected={this.state.selectedIndividual}
                                    showSpin={this.state.showSpin}
                                    currentColor={this.state.currentColor}
                                    currentSet={this.state.currentSet}
                                    currentColorsArray={this.state.currentColorsArray}
                                    currentColorIndex={this.state.currentColorIndex}
                                    handleChangeColors={this.handleChangeColors}
                                    handleCloseSpin={this.handleCloseSpin}
                                /> : null
                            }
                            <TopMenu
                                handleOpenVideo={this.handleShowTuto}
                                handleFullScreen={this.handleFullScreen}
                            />
                            <CarMenu
                                carMenuOpened={this.state.isCarMenuOpened}
                                selectedIndividual={this.state.selectedIndividual}
                                handleShowInterior={this.handleOpenInterior}
                                handleShowSpin={this.handleOpenSpin}
                                handleShowVideo={this.handleOpenVideo}
                                handleShowBaul = {this.handleOpenBaul}
                                isVideo={this.state.isVideo}
                                canvasSelectedIndex={this.state.canvasSelectedIndex}
                            />
                            <Sidebar
                                handleOpenSidebar={this.handleOpenSidebar}
                                openedSidebar={this.state.sidebarOpened}
                                isComerciales={this.props.isComerciales}
                                handleSelectFamily={this.handleSelectFamily}
                                handleSelectIndividual={this.handleSelectIndividual}
                                selectedFamily={this.state.selectedFamily}
                                selectedFamilyIndex={this.state.selectedFamilyIndex}
                            />
                            <VideoComponent
                                isVideo={this.state.isVideo}
                                handleOpenTutorialVideo={this.handleOpenVideo}
                                links={this.state.videoLink}
                            />
                            <Info
                                isInfoOpened={this.state.isInfoOpened}
                                currentInfoImg={this.state.currentInfoImg}
                                currentInfoText={this.state.currentInfoText}
                                handleOpenInfoScreen={this.handleOpenInfoScreen}
                            />
                            <Tutorial
                                isTuto={this.state.isTuto}
                                handleOpenTutorialVideo={this.handlecloseTuto}
                            />
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <Viewer360
                                currentScene={this.state.currentScene}
                                handleChangePano={this.handleChangePano}
                                renderFromMenu={this.state.renderFromMenu}
                                isMobile={this.state.isMobile}
                                handleOpenBullet={this.handleOpenInfoScreen}
                                handleShowInterior={this.handleOpenInterior}
                                isComerciales={this.props.isComerciales}
                            />
                            {
                                this.state.showInterior ?
                                <div className='back-exits' onClick={() => {this.handleOpenInterior(this.state.canvasSelectedIndex, -1)}}>
                                    <img src={back}>
                                    </img>
                                    <div className='back-text'>
                                        Quiero Salir
                                    </div>
                                </div>: null
                            }
                            {this.state.showSpin ?
                                <Viewer3D
                                    individualSelected={this.state.selectedIndividual}
                                    showSpin={this.state.showSpin}
                                    currentColor={this.state.currentColor}
                                    currentSet={this.state.currentSet}
                                    currentColorsArray={this.state.currentColorsArray}
                                    currentColorIndex={this.state.currentColorIndex}
                                    handleChangeColors={this.handleChangeColors}
                                    handleCloseSpin={this.handleCloseSpin}
                                /> : null
                            }
                            <TopMenuMobile
                                handleOpenVideo={this.handleShowTuto}
                            />
                            <CarMenuMobile
                                carMenuOpened={this.state.isCarMenuOpened}
                                selectedIndividual={this.state.selectedIndividual}
                                handleShowInterior={this.handleOpenInterior}
                                handleShowSpin={this.handleOpenSpin}
                                handleShowVideo={this.handleOpenVideo}
                                handleResetStates={this.handleResetStates}
                            />
                            <Sidebar
                                handleOpenSidebar={this.handleOpenSidebar}
                                openedSidebar={this.state.sidebarOpened}
                                isComerciales={this.props.isComerciales}
                                handleSelectFamily={this.handleSelectFamily}
                                handleSelectIndividual={this.handleSelectIndividual}
                                selectedFamily={this.state.selectedFamily}
                                selectedFamilyIndex={this.state.selectedFamilyIndex}
                            />
                            <VideoComponent
                                isVideo={this.state.isVideo}
                                handleOpenTutorialVideo={this.handleOpenVideo}
                                links={this.state.videoLink}
                            />
                            <Info
                                isInfoOpened={this.state.isInfoOpened}
                                currentInfoImg={this.state.currentInfoImg}
                                currentInfoText={this.state.currentInfoText}
                                handleOpenInfoScreen={this.handleOpenInfoScreen}
                            />
                            <Tutorial
                                isTuto={this.state.isTuto}
                                handleOpenTutorialVideo={this.handlecloseTuto}
                            />
                        </React.Fragment>
                }
            </div>
        )
    }
}

export default Canvas
